import { WORKSPACE } from '@common-packages/routes-definitions';

export const SUBPATH_TO_NAMESPACE = Object.values(WORKSPACE).reduce(
  (acc, { namespace, subPath }) => ({
    ...acc,
    [subPath]: namespace,
  }),
  {},
);
